export default "__VITE_ASSET__CZxNLLM3__"